import { useAppSelector } from '@/store/hooks'
import Drawer from '@/components/atoms/Drawer'
import DrawerCourseRecorded from './Recorded'
import DrawerCourseLive from './Live'
import { useEffect } from 'react'

export default function DrawerCourse() {
	const {
		drawer: { drawerInfo },
	} = useAppSelector((state) => state)

		// Bloqueia o scroll da plataforma enquanto o drawer está aberto
		useEffect(() => {
			if (drawerInfo) {
				document.body.style.overflow = 'hidden'
			} else {
				document.body.style.overflow = ''
			}

			// Limpa o efeito quando o componente desmonta ou o drawerInfo muda
			return () => {
				document.body.style.overflow = ''
			}
		}, [drawerInfo])

	return (
		<Drawer>
			{(() => {
				if (
					drawerInfo &&
					['GRAVADO'].includes(drawerInfo?.['type-course']?.toUpperCase())
				) {
					return <DrawerCourseRecorded />
				}

				return <DrawerCourseLive />
			})()}
		</Drawer>
	)
}
